import React, { PureComponent } from 'react';
import {
  CountryDropdown as ReactCountryDropdown,
  RegionDropdown as ReactReginDropdown,
} from 'react-country-region-selector';
import { Dropdown } from 'semantic-ui-react';
import './CompleteForm.css';
import { INDUSTRY_TYPE } from '../../../constants';

const Input = (props) => <input type="text" {...props} />;
const CountryDropdown = (props) => (
  <ReactCountryDropdown {...props} priorityOptions={['US']} />
);
const RegionDropdown = (props) => (
  <ReactReginDropdown {...props} blacklist={{ US: ['FM'] }} />
);

const IndustryDropdown = (props) => (
  <Dropdown
    {...props}
    options={INDUSTRY_TYPE}
    placeholder="Select Industry Type"
    selection
  />
);
const Checkbox = (props) => (
  <input type="checkbox" {...props} checked={props.value} />
);
const Textarea = (props) => <textarea rows="4" {...props} />;

const FIELD_TYPE = {
  input: Input,
  countryDropdown: CountryDropdown,
  stateDropdown: RegionDropdown,
  checkbox: Checkbox,
  textarea: Textarea,
  industryDropdown: IndustryDropdown,
};

const FIELD_CLASSNAME = {
  input: 'inputField',
  countryDropdown: 'DropdownField',
  stateDropdown: 'DropdownField',
  checkbox: 'checkboxField',
  textarea: 'textareaField',
  industryDropdown: 'DropdownField',
};

function checkValidation(value, validation, optional) {
  if (optional) return true;
  return !!value && (!validation || !!value.match(new RegExp(validation)));
}

class FieldWrapper extends PureComponent {
  onChange = (evOrValue, data) => {
    const { field, setFormState } = this.props;
    let value;
    const newFieldState = {};
    switch (field.type) {
      case 'checkbox':
        value = evOrValue.target.checked;
        break;
      case 'countryDropdown':
        newFieldState.state = {};
      case 'stateDropdown':
        value = evOrValue;
        break;
      case 'industryDropdown':
        value = data.value;
        break;
      default:
        value = evOrValue.target.value;
    }
    newFieldState[field.fieldName] = { value };
    setFormState(newFieldState);
  };

  onBlur = () => {
    const { field, setFormState, fieldState } = this.props;
    const { optional, validation, fieldName, inValidText } = field;
    const { value } = fieldState;
    const passValidation = checkValidation(value, validation, optional);
    setFormState({
      [fieldName]: { value, error: !passValidation && inValidText },
    });
  };

  render() {
    const { field, fieldState, country } = this.props;
    const { label, width, optional, type, fieldName } = field;
    const { value, error } = fieldState;
    const Field = FIELD_TYPE[type];
    if (!Field)
      return (
        <div key={fieldName}>{`Missing render function for field ${type}`}</div>
      );
    const fieldLabel = label && `${label}${optional ? '' : '*'}`;
    return (
      <div className={`formField ${FIELD_CLASSNAME[type]}`} style={{ width }}>
        {fieldLabel && <div className="fieldLabel">{fieldLabel}</div>}
        {error && <div className="fieldErrorLabel">{error}</div>}
        <Field
          name={fieldName}
          value={value}
          country={country}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
      </div>
    );
  }
}

export default class CompleteForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formState: { ...props.formState },
      form: this.parseFormData(props),
      submitting: false,
      submitted: false,
    };
  }

  parseFormData = (props) => {
    const { appApi, dealer } = props;
    const fields = appApi.form.getFieldsInOrder(dealer ? 'dealer' : 'public');
    const parsedFields = [];
    let totalWidth = 0;
    let formRow = [];
    for (let idx = 0; idx < fields.length; ++idx) {
      const field = fields[idx];
      const { width } = field;
      const widthAsNum = Number(width.substring(0, width.length - 1));
      if (totalWidth + widthAsNum <= 100) {
        formRow.push(field);
        totalWidth += widthAsNum;
        continue;
      }
      parsedFields.push(formRow);
      formRow = [field];
      totalWidth = widthAsNum;
    }
    parsedFields.push(formRow);
    return parsedFields;
  };

  componentWillReceiveProps(newProps) {
    if (!this.props.dealer ? !!newProps.dealer : !newProps.dealer) {
      this.setState({ form: this.parseFormData(newProps) });
    }
  }

  componentWillUnmount() {
    this.props.setAppState({ formState: this.state.formState });
  }

  setFormState = (newFieldState) => {
    this.setState({
      formState: Object.assign({}, this.state.formState, newFieldState),
    });
  };

  renderDealerDescription = () => (
    <p>
      To place an order, forward email to btorders@bostontec.com and include
      your purchase order.
    </p>
  );

  renderFormFields = () => {
    const { form, formState } = this.state;
    const country = formState.country.value;
    return form.map((formRow, idx) => (
      <div className="formRow" key={`form_row${idx}`}>
        {formRow.map((field) => (
          <FieldWrapper
            key={field.fieldName}
            field={field}
            fieldState={formState[field.fieldName]}
            country={country}
            setFormState={this.setFormState}
          />
        ))}
      </div>
    ));
  };

  onSubmit = async () => {
    const { appApi, configuration, models, dealer, setAppState } = this.props;
    const { formState, form, submitting } = this.state;
    if (submitting) return;
    const inValidFields = {};
    form.forEach((formRow) =>
      formRow.forEach((field) => {
        const { optional, validation, fieldName, inValidText } = field;
        const { value } = formState[fieldName];
        if (!checkValidation(value, validation, optional))
          inValidFields[fieldName] = { value, error: inValidText };
      })
    );
    if (Object.keys(inValidFields).length)
      return this.setFormState(inValidFields);
    const customer = Object.keys(formState).reduce(
      (customer, fieldName) =>
        Object.assign(customer, { [fieldName]: formState[fieldName].value }),
      {}
    );
    appApi.model.deselectModel();
    setAppState({ selectedModel: undefined });
    customer.name = `${customer.firstName} ${customer.lastName}`;
    const newModels = appApi.model.validateModels(configuration, models);
    this.setState({ submitting: true });
    const snapshots = await appApi.order.takeSnapshot();
    const date = new Date();
    const issueDate = `${date.getMonth() +
      1}/${date.getDate()}/${date.getFullYear()}`;
    const metadata = {
      configuration,
      models: newModels || models,
      snapshots,
      dealer,
      issueDate,
      wQty: 1, // need to support nultiply workstation later
      fob: 'MIDLAND, MI',
      bom: this.generateBOMData(newModels),
    };
    await appApi.order.postOrder(customer, metadata).then((res) => res.json());
    this.setState({ submitting: false, submitted: true });
    newModels && setAppState({ models: newModels });
  };

  generateBOMData = (optionalModels) => {
    const { models: stateModels, appApi, configuration } = this.props;
    const models = optionalModels || stateModels;
    function getItemColor(productInfo) {
      const { attribute, label, displayColor } = productInfo;
      if (displayColor !== true) return '';
      if (!attribute.includes('workSurface')) return metalColor.label;
      if (label.includes('Laminate')) return laminateColor.label;
      return metalColor.label;
    }
    function countItem(counter, partNumber) {
      if (!counter[partNumber]) counter[partNumber] = 0;
      counter[partNumber] += 1;
    }
    const itemNum = Object.values(models).reduce((itemNum, model) => {
      const partNumber = model.value;
      if (partNumber.endsWith('*')) {
        const productInfo = appApi.config.getProduct(partNumber);
        productInfo.reference.forEach((ref) => countItem(itemNum, ref));
      } else countItem(itemNum, partNumber);
      return itemNum;
    }, {});
    const metalColor = appApi.config.getProduct(
      configuration.colorStandardPaint.value
    );
    const laminateColor = appApi.config.getProduct(
      configuration.colorStandardLaminate.value
    );

    return Object.entries(itemNum).map(([partNumber, qty]) => {
      const productInfo = appApi.config.getProduct(partNumber);
      return {
        partNumber,
        description: productInfo.quoteDescription,
        listPrice: productInfo.listPrice,
        qty,
        color: getItemColor(productInfo),
      };
    });
  };

  submittedMessage = () => {
    const { submitted } = this.state;
    return submitted ? (
      <div className="submittedMsg">
        Thank you for your inquiry. An email has been sent.
      </div>
    ) : null;
  };

  render() {
    const { dealer } = this.props;
    const { submitting, submitted } = this.state;
    return (
      <div className="completeForm">
        {dealer && this.renderDealerDescription()}
        {this.renderFormFields()}
        <button
          id="config-submit-button"
          className={`submitButton${submitting ? ' disabled' : ''}`}
          onClick={this.onSubmit}
          disabled={submitting || submitted}
        >
          {submitting ? 'SUBMITTING' : submitted ? 'COMPLETE' : 'SUBMIT'}
        </button>
        {this.submittedMessage()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/CompleteForm.js